import { Skeleton } from '@/components/ui/skeleton';
import { formatBatchAmount } from '../utils/formatBatchAmount';

interface BatchFooterAmountProps {
  amount: number | undefined;
}

export function BatchFooterAmount({ amount }: BatchFooterAmountProps) {
  if (amount === undefined) return <Skeleton className="h-4 w-14" />;
  return <span className="tabular-nums">{formatBatchAmount(amount)}</span>;
}
